import {
    ADD_WORKER_MEASUREMENT,
    GET_WORKER_MEASUREMENTS,
    GET_WORKER_MEASUREMENTS_STATS,
    UPLOAD_WORKER_MEASUREMENTS
} from '../actions/WorkerActions'

const initialState = {
    measurments: [],
    measurments_stats: {},
    pageSize: 20,
    total: 0,
    totalPages: 0,
    items:0,
    currentPage:0
}

const UserSettingReducer = function (state = initialState, action) {
    switch (action.type) {
        case ADD_WORKER_MEASUREMENT: {
            return {
                ...state
            }
        }
        case UPLOAD_WORKER_MEASUREMENTS: {
            return {
                ...state
            }
        }
        case GET_WORKER_MEASUREMENTS: {
            return {
                ...state,
                measurments: action.payload.content,
                pageSize: action.payload.size,
                total: action.payload.totalElements,
                totalPages: action.payload.totalPages,
                items: action.payload.numberOfElements,
                currentPage: action.payload.number
            }
        }
        case GET_WORKER_MEASUREMENTS_STATS: {
            return {
                ...state,
                measurments_stats: {...state.measurments_stats, ...action.payload},
            }
        }
        default: {
            return state
        }
    }
}

export default UserSettingReducer
